import axios from "axios";

export default async function printReport(name, id, ...params) {
  const token = localStorage.getItem("token");

  const reports = {
    reportVendaOrcamento: () => reportVendaOrcamento(id, token, ...params),
    receiptStandard: () => receiptStandard(id, token, ...params),
    reportCreaCfta: () => reportCreaCfta(token, ...params),
    reportSimplesDuasVias: () => reportSimplesDuasVias(id, token, ...params),
    reportCoupon: () => reportCoupon(id, token),
    proofOfAcquittance: () => reportProofOfAcquittance(id, token),
    thermalreceipt: () => reportThermalReceipt(id, token),
    thermalSale: () => thermalSale(id, token),
    acquittance: () => printAcquittance(id, token),
    reportOrder: () => reportOrder(id, token),
    reportCoupon58mm: () => reportCoupon(id, token, true),
    reportContrato: () => reportContrato(id, token),
    printInfo: () => infoGeneral(token),
  }

  if (!reports[name]) {
    console.log('invalid name')
    return
  }

  return await reports[name]()
}

function reportVendaOrcamento(id, token, confirmationField = '') {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/${id}?auth=${token}&confirmationField=${confirmationField ? true : ''}`
  );
}
async function receiptStandard(id, token, toSign = false) {
  const url = `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/receipt/standard/${id}?auth=${token}&toSign=${toSign}`;
  
  return await generateReport(url);
}
function reportCreaCfta(token, startDate, endDate, artTrt) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/generate/reports/cfta/crea?auth=${token}&startDate=${startDate}&endDate=${endDate}&artTrt =${artTrt }`
  );
}
function reportSimplesDuasVias (id, token, confirmationField = '') {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/duasVias/${id}?auth=${token}&confirmationField=${confirmationField ? true : ''}`
  );
}
function reportOrder(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/nfse/gerar/relatorio/${id}?auth=${token}`
  );
}
function infoGeneral(token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/print/infoGeral?auth=${token}`
  );
}
function reportCoupon(id, token, is58mm = false) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/coupon/venda/${id}?auth=${token}&is58mm=${is58mm}`
  );
}
function reportProofOfAcquittance(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/bills/generate/print/proof/of/acquittance/A4/${id}?auth=${token}`
  );
}
function reportThermalReceipt(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/bills/generate/print/thermal/${id}?auth=${token}`
  );
}
function thermalSale(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/thermal/${id}?auth=${token}`
  );
}
function printAcquittance(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/safe/look/for/print/transaction/receipt/cashier/${id}?auth=${token}`
  );
}

function reportContrato(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/contrato/venda/and/desktop/${id}?auth=${token}`
  );
}

async function generateReport(url) {
  try {
    const response = await axios.get(url);

    if (response.status !== 200) {
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Erro ao gerar o relatório:", error);
    throw error
  }
}